import Routes from './routes/routes';
import useA11yTracking from './hooks/useA11yTracking';

function App() {
  useA11yTracking();
  return <Routes />;
}

export default App;
